import '../../styles/loading.css';

export default function Loading() {
    return (
        <div className='load'>
            <p>Ładowanie ...</p>
        </div>
    )
};